<template>
    <div>

        <a  @click="onOpen" :class="{'': !isOpen, 'active': isOpen}" class="toggle-filters">
            <span></span><span></span><span></span>
        </a>

        <div :class="{'-right-100vw': !isOpen, 'right-0': isOpen}" class="fixed top-58 w-full max-w-270 h-full p-30 z-40 overflow-y-auto bg-blue-darkest mt-2 transition">
            
            <chart-filtering></chart-filtering>

        </div>
    </div>
</template>

<script>
    import ChartFiltering from "./chartFiltering"

    export default {

        name: "toggle-filters",

        props: {
            value: {
                type: Boolean,
                default: false,
            }
        },

        watch: {
            value(newValue, oldValue) {
                if (newValue !== oldValue) {
                    this.open = newValue
                }
            }
        },

        components: {
          ChartFiltering
        },

        data() {
            return {
                open: this.value,
            }
        },

        computed: {
            isOpen() {
                return this.open
            },
        },

        methods: {
            onOpen() {
                this.open = !this.open

                this.$emit('input', this.open)
            },
        }

    }

</script>